import DefaultView from './back.front.navigation'
import merge from 'lodash/merge'
import { watch } from 'vue'
import Nette from 'nette-base-module/js/nette/Nette'

const webalize = function(s) {
  s = s.toLowerCase()
  let res = '', i, ch
  for (i = 0; i < s.length; i++) {
    if (s.charAt(i) === '%') {
      continue
    }

    ch = Nette.webalizeTable[s.charAt(i)]
    res += ch ? ch : (/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$&()*+,\-./:;<=>?@[\]^_`{|}~\s§]/.test(s.charAt(i)) === false ? encodeURIComponent(s.charAt(i)) : s.charAt(i))
  }
  return res.replace(/[^a-zA-Z0-9%]+/g, '-').replace(/^-|-$/g, '')
};

export default merge({}, DefaultView, {
  mounted () {
    DefaultView.mounted.call(this)
    if (this.$el.classList?.contains('module-container')) {
      const formKey = 'frm-editForm' + this._snippetName + '-'

      watch([() => this.$controls[formKey + 'title'].val, () => this.$controls[formKey + 'url_base'].val], (val) => {
        if (this.$controls[formKey + 'url_lock'].val == 0) {
          //this.$controls[formKey + 'url'].val = (this.$controls[formKey + 'url'].attrs['data-url-base'] || '') + '/' + webalize(val)
          this.$store.dispatch('nette/updateControl', {
            controlName: formKey + 'url',
            data: this.$controls[formKey + 'url_base'].val + '/' + webalize(val[0]),
            key: 'val'
          })
        }
      }, {
        immediate: true
      });
    }
  }
})